import { useMutation, useQueryClient } from '@tanstack/react-query';

import { initiateMemberDataExport } from 'apps-common/graphql/initiateMemberDataExport';
import { InitiateMemberDataExportOutput } from 'apps-common/types';
import { logger } from 'apps-common/utils/logger';

export const useInitMemberDataExport = () => {
  const queryClient = useQueryClient();
  return useMutation<InitiateMemberDataExportOutput>({
    mutationFn: initiateMemberDataExport,
    mutationKey: ['initiateMemberDataExport'],
    onSettled: async () => {
      // Invalidate the query to refresh the data.
      // But first, add a small delay so that the backend has time to process the request and return the correct data.
      await new Promise((resolve) => {
        setTimeout(resolve, 1000);
      });
      await queryClient.invalidateQueries({ queryKey: ['getMemberDataExports'] });
    },
    onError: (error) => {
      logger.debug('initiateMemberDataExport error', { error });
    },
    onSuccess: (response) => {
      logger.debug('Member data export initiated', { response });
    },
  });
};
